module.exports = __webpack_public_path__ + "static/media/phone.8b31cbc4.svg";